import(/* webpackMode: "eager", webpackExports: ["default","SkeletonTheme"] */ "/vercel/path1/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/react-loading-skeleton/dist/skeleton.css");
